import React from "react"
import Horse from '../assets/Horse.png'

const Footer = () => {

    return (<div className="footer">
        <img src={Horse} className="logo" />
        <div className="footerBelow"></div>
    </div>)
}

export default Footer